import { Component } from '@angular/core';
import { UserdataService } from '../../../../service/userdata.service';
import { MatDialog } from '@angular/material/dialog';
import { InviteComponent } from '../../../../components/invite/invite.component';
import { inviteDisabled } from '../../../../../environments/environment';

@Component({
  selector: 'app-teammembers',
  standalone: false,

  templateUrl: './teammembers.component.html',
  styleUrl: './teammembers.component.scss'
})
export class TeammembersComponent {
  user: any;
  inviteDisabled = inviteDisabled;
  constructor(
    private userdata: UserdataService,
    private dialog: MatDialog
  ) {
    this.userdata.data.subscribe(data => {
      this.user = data;
    });
  }

  invte() {
    this.dialog.open(InviteComponent, {
      width: '400px',
      data: this.user
    }
    );
  }
}
